export const APPLICATOR_CERTIFICATIONS_API = '/api/users/me/applicator-certifications';

export const USERS_API = '/api/users';

export const DEFAULT_PAGE_SIZE = 10;

// RS-3426: the admin endpoints mirror the self-service ones under the member's id.
export const getUserApplicatorCertificationsApi = (userId: string): string =>
    `${USERS_API}/${userId}/applicator-certifications`;
